import { useStaticQuery, graphql } from "gatsby"

export const useArtImages = () => {
  const data = useStaticQuery(graphql`
    query {
      _1939_001: file(relativePath: { eq: "img/biography/art-timeline/1939-1949/001-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1939_002: file(relativePath: { eq: "img/biography/art-timeline/1939-1949/002-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1939_003: file(relativePath: { eq: "img/biography/art-timeline/1939-1949/003-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1939_004: file(relativePath: { eq: "img/biography/art-timeline/1939-1949/004-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1939_005: file(relativePath: { eq: "img/biography/art-timeline/1939-1949/005-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1950_001: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/001-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_002: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/002-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_003: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/003-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_004: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/004-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_005: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/005-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_006: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/006-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_007: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/007-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 550, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1950_008: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/008-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_009: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/009-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 550, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1950_010: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/010-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_011: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/011-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_012: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/012-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 550, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1950_013: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/013-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_014: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/014-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1950_015: file(relativePath: { eq: "img/biography/art-timeline/1950-1969/015-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1970_001: file(relativePath: { eq: "img/biography/art-timeline/1970-1979/001.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1970_002: file(relativePath: { eq: "img/biography/art-timeline/1970-1979/002.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1970_003: file(relativePath: { eq: "img/biography/art-timeline/1970-1979/003.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1970_004: file(relativePath: { eq: "img/biography/art-timeline/1970-1979/004.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1970_005: file(relativePath: { eq: "img/biography/art-timeline/1970-1979/005.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1970_006: file(relativePath: { eq: "img/biography/art-timeline/1970-1979/006.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1970_007: file(relativePath: { eq: "img/biography/art-timeline/1970-1979/007.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1970_008: file(relativePath: { eq: "img/biography/art-timeline/1970-1979/008.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1980_001: file(relativePath: { eq: "img/biography/art-timeline/1980-1989/001.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1980_002: file(relativePath: { eq: "img/biography/art-timeline/1980-1989/002.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1980_003: file(relativePath: { eq: "img/biography/art-timeline/1980-1989/003.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1980_004: file(relativePath: { eq: "img/biography/art-timeline/1980-1989/004.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1989_001: file(relativePath: { eq: "img/biography/art-timeline/1989-1999/001.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1989_002: file(relativePath: { eq: "img/biography/art-timeline/1989-1999/002.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1989_003: file(relativePath: { eq: "img/biography/art-timeline/1989-1999/003.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1989_004: file(relativePath: { eq: "img/biography/art-timeline/1989-1999/004.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1989_005: file(relativePath: { eq: "img/biography/art-timeline/1989-1999/005.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1989_006: file(relativePath: { eq: "img/biography/art-timeline/1989-1999/006.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1989_007: file(relativePath: { eq: "img/biography/art-timeline/1989-1999/007.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1989_008: file(relativePath: { eq: "img/biography/art-timeline/1989-1999/008.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1999_001: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/001.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1999_002: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/002.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1999_003: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/003.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1999_004: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/004.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1999_005: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/005.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1999_006: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/006.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1999_007: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/007.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1999_008: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/008.png" }) {
        childImageSharp {
          fluid(maxWidth: 550, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _1999_009: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/009.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1999_010: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/010.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1999_011: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/011.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _1999_012: file(relativePath: { eq: "img/biography/art-timeline/1999-2005/012.png" }) {
        childImageSharp {
          fluid(maxWidth: 550, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `)
  return data
}
